/*
'use strict';

angular.module('amexReconciliationApp')
  .service('PreferredAccountingFieldSchemaModel', function PreferredAccountingFieldSchemaModel($rootScope,
                                                                                               ModelFactory,
                                                                                               $translate,
                                                                                               PreferredAccountingFieldSchemaRepository) {

    var model = ModelFactory.create('PreferredAccountingFieldSchemaModel', [
      'firstAccountingFieldSchema',
      'secondAccountingFieldSchema'
    ]);

    model.fetchPreferredAccountingFields = function(newSiteConfig) {
      PreferredAccountingFieldSchemaRepository.findBySiteNumber(newSiteConfig.siteNumber)
        .then(function (preferredSchemas) {
          var schemas = model.accountingFieldSchemas(newSiteConfig);

          var firstPreferedAccountingFieldSchema = schemas[0];
          var secondPreferedAccountingFieldSchema = schemas[1];

          if(!_.isEmpty(preferredSchemas)) {
            var firstPreferredSchema = _.find(preferredSchemas, ['columnPosition', 0]);
            var secondPreferredSchema = _.find(preferredSchemas, ['columnPosition', 1]);

            firstPreferedAccountingFieldSchema = _.find(schemas, ['position', firstPreferredSchema.accountingFieldSchemaPosition]);
            secondPreferedAccountingFieldSchema = _.find(schemas, ['position', secondPreferredSchema.accountingFieldSchemaPosition]);
          } else {
            updatePreferredAccountingFieldSchema(newSiteConfig.siteNumber, 0, firstPreferedAccountingFieldSchema);
            updatePreferredAccountingFieldSchema(newSiteConfig.siteNumber, 1, secondPreferedAccountingFieldSchema);
          }

          model.firstAccountingFieldSchema(firstPreferedAccountingFieldSchema);
          model.secondAccountingFieldSchema(secondPreferedAccountingFieldSchema);
        });
    };

    model.accountingFieldSchemas = function (siteConfig) {
      var schemas = _.cloneDeep(_.get(siteConfig, 'accountingFieldSchemas', []));
      schemas.push({label: $translate.instant('transactions.AllocationDescription'), position: -1});
      return schemas;
    };

    model.updatePreferredAccountingFieldSchema = updatePreferredAccountingFieldSchema;

    function updatePreferredAccountingFieldSchema(siteNumber, columnPosition, schema) {
      if (schema !== undefined) {
        PreferredAccountingFieldSchemaRepository.update(siteNumber, columnPosition, schema.position);
      }
    }

    return model;
  });
*/



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/PreferredAccountingFieldSchemaModel.js
// module id = 583
// module chunks = 0